<template>
  <svg width="1.25rem" height="1.25rem" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"></path>
  </svg>
</template>

<script>
export default {
  name: "MdiPlus",
};
</script>
